const H4 = ({ children }) => <h4 className="mt-4 font-bold text-[#1e3a5f]">{children}</h4>;
const Cite = ({ cite }) => <span className="text-slate-500 text-[10px]">[{cite}]</span>;

function ItemList({ items }) {
  return <ol className="list-decimal pl-5">{items.map((it) => <li key={`${it.cite}|${it.text}`}>{it.text} <Cite cite={it.cite} />{it.note && <i> — {it.note}</i>}</li>)}</ol>;
}

function LetterHead({ L }) {
  return (
    <>
      {L.company_line && <div className="text-[10px] text-slate-500 border-b border-slate-200 pb-1 mb-1" data-testid="letter-preview-company">{L.company_line}</div>}
      <div className="text-slate-500">{L.date}</div>
      <div className="mt-2"><b>To:</b> {L.to.name}{L.to.company ? `, ${L.to.company}` : ""}</div>
      <div><b>Re:</b> Bid Clarifications and Exclusions — {L.project.name}{L.proposal_number ? ` · Proposal No. ${L.proposal_number}` : ""}{L.project.number ? ` · Project No. ${L.project.number}` : ""}</div>
      <table className="mt-3 text-[11px]"><tbody>{L.info.map(([k, v]) => <tr key={k} className="border-b border-slate-200"><td className="pr-4 py-0.5 font-semibold align-top">{k}</td><td className="py-0.5">{v}</td></tr>)}</tbody></table>
      <p className="mt-3">{L.opening}</p>
    </>
  );
}

function ScopeSection({ L }) {
  if (!L.include_scope) return null;
  return (
    <>
      <H4>{L.sections.scope}. Scope of Work Included</H4>
      {L.scope_groups.length === 0 && <div>No specification requirements have been selected as included in this proposal.</div>}
      {L.scope_groups.map((g) => <div key={g.category} data-testid={`letter-scope-${g.category}`}><div className="mt-2 font-semibold text-emerald-700">{g.category}</div><ItemList items={g.items} /></div>)}
    </>
  );
}

function PriceBox({ L }) {
  return (
    <>
      <div className="mt-3 border border-[#1e3a5f] rounded" data-testid="letter-price-box">
        <div className="flex justify-between items-center bg-slate-100 px-3 py-2"><b>{L.price.label.toUpperCase()}</b><b className="text-[14px] font-mono">{L.price.amount ? `$${L.price.amount}` : "$ ______________"}</b></div>
        <div className="px-3 py-1.5">{L.price.terms}{L.validity ? ` · ${L.validity}` : ""}<div className="italic text-slate-600">Note: {L.price.tax_note}</div></div>
      </div>
      {L.alternates.length > 0 && <div className="mt-2" data-testid="letter-preview-alternates"><div className="font-semibold text-amber-700">Alternates</div>{L.alternates.map((a) => <div key={a.n} className="flex justify-between border-b border-slate-200 py-0.5"><span><b>Alternate No. {a.n}</b> ({a.kind === "add" ? "Add" : "Deduct"}): {a.description}</span><b className="font-mono">{a.kind === "add" ? "+" : "−"} {a.amount ? `$${a.amount}` : "$ ________"}</b></div>)}</div>}
    </>
  );
}

function ExclusionSections({ L }) {
  return (
    <>
      <H4>{L.sections.standard}. Standard Exclusions</H4>
      <ol className="list-decimal pl-5">{L.standard_exclusions.map((e) => <li key={e}>{e}</li>)}</ol>
      <H4>{L.sections.struck}. Specification Requirements Excluded From This Proposal</H4>
      {L.struck_groups.length === 0 && <div>None — all identified fabricator requirements are carried in our proposal.</div>}
      {L.struck_groups.map((g) => <div key={g.kind} data-testid={`letter-group-${g.kind}`}><div className="mt-2 font-semibold text-amber-700">{g.title}</div><ItemList items={g.items} /></div>)}
      <H4>{L.sections.clarifications}. Clarifications</H4>
      {L.finding_clarifications.length === 0 && <div>No additional clarifications.</div>}
      <ol className="list-decimal pl-5">{L.finding_clarifications.map((c) => <li key={c.n}>{c.text} <Cite cite={c.cite} /></li>)}</ol>
    </>
  );
}

export function LetterPreview({ L }) {
  return (
    <div className="border border-slate-800 rounded bg-white text-slate-900 p-5 text-[12px] leading-relaxed font-serif max-h-[45vh] overflow-y-auto" data-testid="letter-preview">
      <LetterHead L={L} />
      <ScopeSection L={L} />
      <PriceBox L={L} />
      <ExclusionSections L={L} />
      <p className="mt-4">{L.closing}</p>
      <p className="mt-3">Respectfully,</p>
      <p className="mt-4"><b>{L.signer.name}</b><br />{L.signer.title}<br />{L.workspace}{L.signer.email ? <><br />{L.signer.email}</> : null}</p>
    </div>
  );
}
